import { render } from "./TheMessageTextIndexPage.vue?vue&type=template&id=fc6d6178&class=px-1.5"
import script from "./TheMessageTextIndexPage.vue?vue&type=script&lang=js"
export * from "./TheMessageTextIndexPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__